import React, { Component } from "react";
import {
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormattedMessage } from "react-intl";
import { signOutAction } from "../../actions/authActions";
import { connect } from "react-redux";

class MobileLogout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdownOpen: false
    };
  }

  signOut = () => {
    this.props.signOutAction();
  };

  toggle = () => {
    this.setState({ dropdownOpen: !this.state.dropdownOpen });
  };

  render() {
    var role = localStorage.getItem("role") ? localStorage.getItem("role") : "";
    var email = localStorage.getItem("email");
    var displayRole = "Views.Header.DisplayLoginRole" + role;

    if (role !== "") {
      return (
        <ButtonDropdown
          id="mobile__logout"
          isOpen={this.state.dropdownOpen}
          toggle={this.toggle}
        >
          <DropdownToggle id="mobile__logout-toggler">
            <FontAwesomeIcon
              title="Info"
              icon="user"
              style={{ cursor: "pointer" }}
            />
          </DropdownToggle>
          <DropdownMenu id="mobile__logout-menu">
            <DropdownItem header>
              <FormattedMessage id="Views.Header.DisplayLoginRole" />
              &nbsp;{email} (<FormattedMessage id={displayRole} />)
            </DropdownItem>
            <DropdownItem divider />
            <DropdownItem onClick={this.signOut}>Logga ut</DropdownItem>
          </DropdownMenu>
        </ButtonDropdown>
      );
    } else {
      return null;
    }
  }
}

export default connect(null, { signOutAction })(MobileLogout);
